import { createContext } from 'react'

const editorContext = createContext({})

export default editorContext
